import * as yup from 'yup';
import { validateSsn } from '../../../../helpers/formHelpers/formHelpers';
import { getCurrentLangPretty } from '../../../../helpers/url/urlHelpers';
import { IFormSelectOption } from '../../../../interfaces/forms/forms';

export interface IRecipient {
	country: IFormSelectOption;
	receiverSsn: string;
	receiverName: string;
	receiverAddress: string;
	receiverPostCode: IFormSelectOption;
	receiverPhone: string;
	receiverEmail: string;
	receiverForeignPostCode: string;
	receiverForeignAddressExtended: string;
	receiverForeignPlace: string;
}

export const recipientInitialValues: IRecipient = {
	country: { value: 'IS', label: getCurrentLangPretty() === 'is' ? 'Ísland' : 'Iceland' },
	receiverSsn: '',
	receiverName: '',
	receiverAddress: '',
	receiverPostCode: null,
	receiverPhone: '',
	receiverEmail: '',
	receiverForeignPostCode: '',
	receiverForeignAddressExtended: '',
	receiverForeignPlace: '',
};

const yupFormSelectOption = {
	label: yup.string(),
	value: yup.string(),
};

export const recipientSchema = yup.object().shape({
	receiverName: yup.string().required('step-info.address-required'),
	receiverSsn: yup.string().test('is-valid-ssn', 'step-info.ssn-valid', validateSsn),
	receiverAddress: yup.string().max(35, 'step-info.max').required('step-info.address-required'),

	receiverPostCode: yup.object().when('country', {
		is: val => (val ? val.value === 'IS' : false),
		then: yup.object().nullable().shape(yupFormSelectOption).required('step-info.poscode-required'),
		otherwise: yup.object().nullable().shape(yupFormSelectOption),
	}),

	receiverForeignPostCode: yup.string().when('country', {
		is: val => (val ? val.value !== 'IS' : false),
		then: yup.string().required('step-info.address-required'),
		otherwise: yup.string(),
	}),
	receiverForeignPlace: yup.string().when('country', {
		is: val => (val ? val.value !== 'IS' : false),
		then: yup.string().required('step-info.address-required'),
		otherwise: yup.string(),
	}),
});
